import { render, staticRenderFns } from "./my-font.vue?vue&type=template&id=305d6f6c&scoped=true&"
import script from "./my-font.vue?vue&type=script&lang=js&"
export * from "./my-font.vue?vue&type=script&lang=js&"
import style0 from "./my-font.vue?vue&type=style&index=0&id=305d6f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305d6f6c",
  null
  
)

export default component.exports